import {
  ThemeInput,
  teamsTheme,
  teamsDarkTheme,
  teamsHighContrastTheme,
  mergeThemes,
  ThemePrepared,
} from '@fluentui/react-northstar';
import { useEffect, useState } from 'react';

import CommonTheme from '../themes/common';

const useTheme = () => {
  const [theme, setTheme] = useState<ThemeInput>(teamsTheme);
  const [themeName, setThemeName] = useState<string | undefined>(undefined);

  useEffect(() => {
    let mergedTheme: ThemePrepared;

    switch (themeName) {
      case 'dark':
        mergedTheme = mergeThemes(teamsDarkTheme, CommonTheme);
        break;
      case 'contrast':
        mergedTheme = mergeThemes(teamsHighContrastTheme, CommonTheme);
        break;
      case 'default':
      default:
        mergedTheme = mergeThemes(teamsTheme, CommonTheme);
        break;
    }

    setTheme(mergedTheme);
  }, [themeName]);

  return { theme, setThemeName };
};

export default useTheme;
